import React, { useState, createContext } from "react"

import localizationFi from "../localization/fi.json"
import localizationDe from "../localization/de.json"
import localizationEn from "../localization/en.json"
import localizationEs from "../localization/es.json"
import localizationZh from "../localization/zh.json"

const defaultLanguage = process.env.GATSBY_LOCALE.toLowerCase()
const translations = {
  fi: localizationFi,
  de: localizationDe,
  es: localizationEs,
  en: localizationEn,
  zh: localizationZh,
}

export const LocalizationContext = createContext({
  language: defaultLanguage,
  setLanguage: () => {},
  translate: () => "",
  getLocale: () => "",
})

export const LocalizationStore = ({ children, location }) => {
  const [language, setLanguage] = useState(defaultLanguage)
  const translate = (str, params, lang = language) => {

    if (!str) return ""
    const langTranslations = translations[lang] || translations[defaultLanguage]
    let val = str
      .split(".")
      .reduce((prev, curr) => prev && prev[curr], langTranslations)
    if (!val && val !== "") return `No translations for ${str} in ${lang}`
    for (let param in params) {
      val = val.split("${" + param + "}").join(params[param])
    }
    return val
  }

  const getLocale = () => {
    if (language === "de") {
      return "de"
    } else if (language === "es") {
      return "es"
    } else if (language === "zh") {
      return "zh"
    } else if (language === "fi") {
      return "fi"
    }
    return "en"
  }
  return (
    <LocalizationContext.Provider
      value={{
        language,
        setLanguage,
        translate,
        getLocale,
      }}
    >
      {children}
    </LocalizationContext.Provider>
  )
}
